import { render } from "./LoadedCategoriesDialog.vue?vue&type=template&id=e8851082&scoped=true"
import script from "./LoadedCategoriesDialog.vue?vue&type=script&lang=js"
export * from "./LoadedCategoriesDialog.vue?vue&type=script&lang=js"

import "./LoadedCategoriesDialog.vue?vue&type=style&index=0&id=e8851082&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8851082"]])

export default __exports__